export default {
  'register.title': 'Member Registration',
  'register.phone': 'Phone Number',
  'register.phone.required': 'Please input your phone number',
  'register.phone.format': 'Please enter a valid Australian mobile number starting with 04',
  'register.phone.placeholder': 'Enter your mobile number (e.g., 0412345678)',
  'register.phone.verify': 'Verification Code',
  'register.phone.verify.get': 'Get Code',
  'register.phone.verify.required': 'Please input verification code',
  'register.phone.verify.sent': 'Verification code sent successfully',
  'register.phone.verify.failed': 'Failed to send verification code',
  'register.phone.verify.invalid': 'Invalid verification code',
  'register.firstName': 'First Name',
  'register.firstName.required': 'Please input your first name',
  'register.middleName': 'Middle Name',
  'register.lastName': 'Last Name',
  'register.lastName.required': 'Please input your last name',
  'register.email': 'Email',
  'register.email.placeholder': 'Optional',
  'register.email.placeholder.required': 'Please enter your email',
  'register.email.required': 'Please input your email',
  'register.email.invalid': 'Please enter a valid email address',
  'register.birthday': 'Birthday',
  'register.birthday.placeholder': 'Select your birthday',
  'register.ageGroup': 'Age Group',
  'register.ageGroup.required': 'Please select your age group',
  'register.ageGroup.placeholder': 'Please select your age group',
  'register.ageGroup.under-18': 'Under 18 years',
  'register.ageGroup.18-25': '18-25 years',
  'register.ageGroup.26-35': '26-35 years',
  'register.ageGroup.36-45': '36-45 years',
  'register.ageGroup.46-55': '46-55 years',
  'register.ageGroup.56-65': '56-65 years',
  'register.ageGroup.65+': '65+ years',
  'register.password': 'Password',
  'register.password.required': 'Please input your password',
  'register.password.min': 'Password must be at least 6 characters',
  'register.password.max': 'Password cannot be longer than 16 characters',
  'register.password.confirm': 'Confirm Password',
  'register.password.confirm.required': 'Please confirm your password',
  'register.password.confirm.mismatch': 'The two passwords do not match',
  'register.submit': 'Register',
  'register.success': 'Registration successful',
  'register.fail': 'Registration failed, please try again',
};
